var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('ModalSimple',{ref:_vm.SIMPLE}),_c('ModalTrialToBasic',{ref:_vm.TRIAL_TO_BASIC}),_c('ModalRecommendation',{ref:_vm.RECOMMENDATION}),_c('ModalSecretQuestion',{ref:_vm.SECRET_QUESTION})],1)}
var staticRenderFns = []

export { render, staticRenderFns }